function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".clsp-1{fill:none;}.clsp-2{fill:#098ef6;}.clsp-3{clip-path:url(#clip-path);}.clsp-4{fill:#fff;}.clsp-5{fill:#ccc;}"), React.createElement("clipPath", {
  id: "clip-path",
  transform: "translate(0 0)"
}, React.createElement("circle", {
  className: "clsp-1",
  cx: 74.5,
  cy: 74.5,
  r: 74.5
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "paydayLogo");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("circle", {
  className: "clsp-2",
  cx: 74.5,
  cy: 74.5,
  r: 74.5
}), React.createElement("g", {
  className: "clsp-3"
}, React.createElement("path", {
  className: "clsp-4",
  d: "M48.07,119.24V155H37.86V32.57H96c57.52,0,57.52,86.67,0,86.67Zm0-77.21V110H96C140,110,140,42,96,42Z",
  transform: "translate(0 0)"
}), React.createElement("path", {
  className: "clsp-5",
  d: "M37.5,67V42.1H12.67V31.68H37.5V6.93H48.08V31.68H72.91V42.1H48.08V67Z",
  transform: "translate(0 0)"
}))));

var SvgPaydayLogo = function SvgPaydayLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 149 155",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaydayLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paydayLogo.56f0d292.svg";
export { ForwardRef as ReactComponent };